// extracted by mini-css-extract-plugin
module.exports = {"s1bu4bpm":"s1bu4bpm"};